// extracted by mini-css-extract-plugin
export default {"container":"CategoryLandingPage_container__KV4bk"};